import React, { useState } from "react";
import { Form, Input, Button, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { firestore, storage } from "../../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";
import CircularProgress from "@mui/material/CircularProgress";
import MuiImageUpload from "../../componets/MuiImageUpload";

const AddPost = ({}) => {
  const [form] = Form.useForm();

  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [fileList, setFileList] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleAddPost = async () => {
    setLoading(true);
    try {
      const newPost = {
        timestamp: Date.now(),
      };

      if (title) {
        newPost.title = title;
      }

      if (content) {
        newPost.content = content;
      }
      if (
        (!newPost?.content || newPost?.content === "") &&
        images?.length === 0
      ) {
        form.setFields([
          {
            name: "content", // required
            value: "", //optional
            errors: [""],
          },
          {
            name: "image", // required
            value: "", //optional
            errors: ["Content or image is required"],
          },
        ]);
        setLoading(false);
        return;
      }

      let errors = form.getFieldsError();
      errors = errors
        .filter((el) => el.errors.length > 0)
        .map((el) => el.errors[0]);
      if (errors.length > 0) return;

      if (images?.length > 0) {
        const imageUrls = await Promise.all(
          images.map(async (image) => {
            const uniqueFilename = `${Date.now()}-${uuidv4()}`;
            const storageRef = ref(storage, `postImages/${uniqueFilename}`);
            await uploadBytes(storageRef, image);
            return getDownloadURL(storageRef);
          })
        );

        newPost.images = imageUrls;
      }
      newPost.viewCount = 0;
      const postRef = doc(firestore, "posts", newPost.timestamp.toString());
      await setDoc(postRef, newPost);
      // await addDoc(collection(firestore, "posts"), newPost);

      form.resetFields();
      setTitle("");
      setContent("");
      setImages(null);
      setPreviewImage(null);
      setFileList([]);
      message.success("Post added successfully!");
      setLoading(false);
      axios
        .post(base_url + "/sent-notification")
        .then((res) => {
          console.log("Response-------", res);
        })
        .catch((err) => {
          console.log("Error in sending notification--");
        });
      navigate("/posts");
    } catch (error) {
      setLoading(false);
      message.error(
        "Failed to add post. Please check the form fields and try again."
      );
    }
  };

  return (
    <div
      style={{
        alignItems: "center",
        overflow: "auto",
        maxHeight: "100vh",
        paddingRight: "0px",
        width: "97.5%",
      }}
    >
      <h2>Add Post</h2>

      <Form
        form={form}
        onFinish={handleAddPost}
        clabelcol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Title is required" },
            { min: 3, message: "Minimum 3 characters required" },
          ]}
        >
          <Input
            style={{
              width: "100%",
              height: 50,
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginLeft:22
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          label="Content"
          name="content"
          rules={[ { required: true, message: "Content is required" },{ min: 20, message: "Minimum 20 characters required" }]}
        >
          <Input.TextArea
            style={{
              width: "100%",
              height: 200,
              overflow: "hidden",
              whiteSpace: "wrap",
            }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </Form.Item>

        <MuiImageUpload
          maxImages={5}
          label="Upload Post Images"
          onChange={(images) => {
            setImages(images);
          }}
        />
        <Form.Item> 
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            <Button
              type="primary"
              htmlType="submit"
              disabled={!(title || content || images?.length > 0)}
              style={{marginTop:50}}
            >
              Add Post
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddPost;
